import {useState} from 'react';

import _ from '../../utils/_';
import Minus from '../icons-af/minus';
import Plus from '../icons-af/plus';
import {H5} from '../typography/typography';
import './collapsible.scss';

const Accordion = ({
  label,
  children,
  open = false,
  onOpen = _.noop,
  isButton = false,
  onToggle,
}: propTypes) => {
  const [isOpen, setIsOpen] = useState(open);
  const iconSize = '19px';

  const handleClick = () => {
    if (isButton) {
      onOpen();
      return;
    }

    if (onToggle) {
      onToggle(!isOpen);
      setIsOpen(!isOpen);
    } else {
      setIsOpen(!isOpen);
      if (!isOpen) {
        setTimeout(onOpen, 0);
      }
    }
  };

  return (
    <div className="collapsible">
      <div
        className="collapsible-toggler"
        role="button"
        aria-expanded={isOpen}
        onClick={handleClick}
      >
        <H5 style="p1">{label}</H5>
        {isOpen ? (
          <Minus width={iconSize} height="100%" />
        ) : (
          <Plus width={iconSize} height="100%" />
        )}
      </div>
      <div className={'collapsible-content' + (isOpen ? ' show' : '')}>{children}</div>
    </div>
  );
};

interface propTypes {
  label: any;
  children?: any;
  open?: boolean;
  onOpen?: () => any;
  isButton?: boolean;
  onToggle?: (state: boolean) => void;
}

export default Accordion;
